import uuid from '../../utils/uuid';

class TransactionSession {
  constructor() {
    this.data = {};
  }

  open(context, isDedicated = false) {
    const { id } = this.data;

    if (id) {
      throw new Error('Another transaction session is opened now');
    }

    this.data = {
      id: uuid(),
      context,
      isDedicated,
    };
  }

  get() {
    return this.data;
  }

  setInitialState(state) {
    const { id } = this.data;

    if (!id) {
      throw new Error('Transaction session should be opened before setting the state');
    }

    this.data.initialState = state;
  }

  setState(state) {
    const { id, initialState } = this.data;

    if (!id) {
      throw new Error('Transaction session should be opened before setting the state');
    }

    if (!initialState) {
      throw new Error('The initial state should be set before');
    }

    this.data.state = state;
  }

  clearState() {
    delete this.data.state;
  }

  reset() {
    this.data = {};
  }
}

export default TransactionSession;
